<template>
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-6">                
                <div class="form-group">
                    <label class="control-label">Tipo  de póliza</label>
                    <select v-model="store.tipoPoliza" class="form-control" required="required" @change="controlPoliza()">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option v-for="tipo in tiposPoliza" :key="tipo.id" :value="tipo.id">{{ tipo.nombre }}</option>   
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">                    
                    <label class="control-label">Tipo de nómina</label>                    
                    <select class="form-control" required="required">
                        <option value="" disabled selected>Seleccione una opción</option>
                        <option>Federal</option>
                        <option>Estatal</option>                        
                    </select>                
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Organización</label>
                    <select class="form-control" required="required" :disabled="disabledOrganizaciones" v-model="store.organizacion" @change="controlOrganizacion()">
                        <option value="" disabled selected>Seleccione una opción</option>                        
                        <option v-for="organizacion in store.organizaciones" :key="organizacion.id" :value="organizacion.id">{{ organizacion.nombre }}</option>
                    </select>
                </div>
            </div>            
            <div class="col-md-6">
                <div class="form-group">
                    <label class="control-label">Unidad</label>
                    <select class="form-control" required="required" :disabled="disabledUnidades" v-model="store.unidad">
                        <option value="" disabled selected>Seleccione una opción</option>                        
                        <option v-for="unidad in store.unidades" :key="unidad.id" :value="unidad.id">{{ unidad.nombre }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="control-label">Referencia particular</label>
                    <textarea v-model="store.referencia" :disabled="disabledReferencia" class="form-control" rows="3" style="resize: none;" placeholder="Describa la ubicación particular del puesto de trabajo" required="required" />                                           
                </div>
            </div>           
        </div>
    </div>
</template>

<script>
import { useSeguroStore } from '@/stores/seguroStore';

export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            errors: [],
            formSubmitted: false,
            tiposPoliza: [{ id: 1, nombre: 'Institucional' }, { id: 2, nombre: 'Individual' }, { id: 3, nombre: 'Colectiva' }],
            // organizaciones: this.store.organizaciones,
            disabledOrganizaciones: 0,
            disabledUnidades: 0,
            disabledReferencia: 0,
        }
    },    
    methods: {
        controlPoliza() {
            if (this.store.tipoPoliza && this.store.tipoPoliza.id === 2) {
                this.disabledOrganizaciones = 0;
                // if (this.tipoPoliza.id === 2) { // Institucional
                    
                // }
            }
        },    
        controlOrganizacion() {
            if (this.organizacionSeleccionada && this.organizacionSeleccionada.id) {
                alert('entra');
                this.disabledUnidades = 0;                
            }
        },  
        onSubmit() {
            this.formSubmitted = true;
            this.errors = [];
            if (this.firstname.length < 3 || this.firstname > 10 && this.lastname.length < 3 || this.lastname.length > 10) {
                this.firstError = true;
                this.lastError = true;
                this.errors.push({
                });
            } else {
                this.firstError = false;
                this.lastError = false;
                this.errors.push({

                });
            }
        }
    }
}
</script>